import moment from "moment"
import React from "react"
import { IGroupProduct } from "../../views/ecommerce/group/interfaces"
import { ITableContentGroupsProducts } from "./interface"
import { Td, Tr } from "./style"

const TableContentGroupsProducts = ({
    listGroups,
    setSelectedGroup
}: ITableContentGroupsProducts
): React.ReactElement => (
        <>
            {
                listGroups.map((group: IGroupProduct, index: number) => {
                    return (
                        <Tr key={group.id}>
                        <Td>
                            { index + 1 }
                        </Td>
                        <Td>
                            { group.description }
                        </Td>
                        <Td>
                            { group.active ? "Ativo" : "Inativo" }
                        </Td>
                        <Td>R$ {(parseInt(group.amount) / 100).toLocaleString("pt-br", { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</Td>
                        <Td>{moment(group.created_at).format("DD/MM/YYYY")}</Td>
                        <Td>{moment(group.updated_at).format("DD/MM/YYYY")}</Td>
                    </Tr>
                    )
                })
            }
        </>
    )

export default TableContentGroupsProducts